/// <reference path="./symbol.d.ts" />
import { ETextAlign, PageGen, PdfBrush, PdfFont, PdfRect } from '../pdf';
import { GUtil } from '../gutil';

export enum ESymbol {
  BlackBishop = 0xe000,
  BlackKing = 0xe001,
  BlackKnight = 0xe002,
  BlackPawn = 0xe003,
  BlackQueen = 0xe004,
  BlackRook = 0xe005,
  Boat1 = 0xe006,
  Camera1 = 0xe007,
  Camera2 = 0xe008,
  Camera3 = 0xe009,
  Car1 = 0xe00a,
  Card10 = 0xe00b,
  Card2 = 0xe00c,
  Card3 = 0xe00d,
  Card4 = 0xe00e,
  Card5 = 0xe00f,
  Card6 = 0xe010,
  Card7 = 0xe011,
  Card8 = 0xe012,
  Card9 = 0xe013,
  CardA = 0xe014,
  CardClub = 0xe015,
  CardDiamond = 0xe016,
  CardHearts = 0xe017,
  CardJ = 0xe018,
  CardK = 0xe019,
  CardQ = 0xe01a,
  CardSpade = 0xe01b,
  CardStar = 0xe01c,
  Crown = 0xe01d,
  FullCrescent = 0xe01e,
  FullCross = 0xe01f,
  FullHeart = 0xe020,
  FullHexagon = 0xe021,
  FullKite = 0xe022,
  FullLeftTriangle = 0xe023,
  FullOctagon = 0xe024,
  FullParellelogram = 0xe025,
  FullPentagon = 0xe026,
  FullPic = 0xe027,
  FullRightTriangle = 0xe028,
  FullStar = 0xe029,
  Heli1 = 0xe02a,
  KeyBackspace = 0xe02b,
  KeyDown = 0xe02c,
  KeyEnter = 0xe02d,
  KeyLeft = 0xe02e,
  KeyMenu = 0xe02f,
  KeyRight = 0xe030,
  KeyTab = 0xe031,
  KeyUp = 0xe032,
  KeyWin = 0xe033,
  Logo = 0xe034,
  Motorcycle1 = 0xe035,
  Pig = 0xe036,
  Plane1 = 0xe037,
  Rings = 0xe038,
  ShapeRing = 0xe039,
  ShapeSquare = 0xe03a,
  ShapeTriangle = 0xe03b,
  SignStop1 = 0xe03c,
  SignStop2 = 0xe03d,
  TickNo = 0xe03e,
  TickYes = 0xe03f,
  Train1 = 0xe040,
  Truck1 = 0xe041,
  WhiteBishop = 0xe042,
  WhiteKing = 0xe043,
  WhiteKnight = 0xe044,
  WhitePawn = 0xe045,
  WhiteQueen = 0xe046,
  WhiteRook = 0xe047,
}

PageGen.prototype.drawSymbol = function (
  symbol: ESymbol,
  brush: PdfBrush,
  rect: PdfRect,
  fontSize = 24,
  align: ETextAlign = ETextAlign.Center
): void {
  const char = String.fromCodePoint(symbol);
  const font = new PdfFont(PdfFont.SYMBOL_FONT_NAME, fontSize);
  this.drawString(char, font, brush, null, rect, align);
};
